import { memo, useState } from "react";
import { AttendeeNote } from "../../types/Types";
import { getInitials } from "../../utils/connectionUserUtils";
import { attendeeAsUser } from "./attendeeNotesShared";

const NoteAvatar = memo(function NoteAvatar({ note }: { note: AttendeeNote }) {
  const [imgFailed, setImgFailed] = useState(false);
  const initials = getInitials(attendeeAsUser(note));

  if (!note.attendeePhoto || imgFailed) {
    return (
      <div
        className="d-flex align-items-center justify-content-center text-white fw-bold rounded-circle flex-shrink-0"
        style={{
          width: 48,
          height: 48,
          background: "linear-gradient(180deg, #031B3D 0%, #082F6F 100%)",
          fontSize: 14,
        }}
      >
        {initials}
      </div>
    );
  }

  return (
    <img
      src={note.attendeePhoto}
      alt=""
      className="rounded-circle flex-shrink-0"
      width={48}
      height={48}
      style={{ objectFit: "cover" }}
      onError={() => setImgFailed(true)}
    />
  );
});

export default NoteAvatar;
